import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

const UserProductPayment = () => {
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);

  // ✅ Get values directly from URL
  const { amount} = useParams();
  const amountInPaise = Number(amount) * 100;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => setRazorpayLoaded(true);
    script.onerror = () => console.error('Failed to load Razorpay script');
    document.body.appendChild(script);
  }, []);

  const handleClick = () => {
    if (!razorpayLoaded || typeof window.Razorpay === 'undefined') {
      alert('Razorpay SDK failed to load. Please try again later.');
      return;
    }

    const options = {
      key: 'rzp_live_DFlbGU4ZrBz1UT',
      amount: amountInPaise,
      currency: 'INR',
      name: 'BakPoket Pvt Ltd',
      description: 'Dynamic Payment',
      image: 'https://yourcdn.com/logo.png',
      handler: function (response) {
        alert('Payment Successful!');
        console.log(response);
      },
      prefill: {
        name: 'User',
        email: 'user@example.com',
      },
      notes: {
        address: 'BakPoket HQ',
      },
      theme: {
        color: '#3399cc',
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };


  return (
    <Card>
      <h2>Payment Section</h2>
      <p>Amount: ₹{amount}</p>
      <button onClick={handleClick}>Pay ₹{amount}</button>
      <br />
    </Card>
  );
};

export default UserProductPayment;


const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  text-align: center;
  margin: 50px auto;

  h2 {
    font-size: 22px;
    margin-bottom: 10px;
    color: #2a4157;
  }

  p {
    font-size: 16px;
    margin: 5px 0;
  }

  button {
    padding: 10px 15px;
    background-color: #ef4766;
    border: none;
    color: white;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
    transition: background 0.3s;

    &:hover {
      background-color: #d63c5b;
    }
  }

  @media (max-width: 768px) {
    max-width: 220px;
    width: 85%;
    padding: 10px;

    h2 {
      font-size: 14px;
    }

    button {
      font-size: 12px;
      padding: 8px 12px;
    }
  }
`;
